<template>
  <div class="col" v-if="selectedTab == 'betSlipTab'"> <!-- removed style="margin-top:2em" -->
    <div class="load-data-wrap col not-list">
      <template v-if="statement.last10wagerList.length > 0 && !reloadingBet">
        <div data-v-21f17103="" class="fit">
          <div data-v-72a40ca0="" data-v-21f17103="" data-container="bet-record-container" class="bet-record-container">
            <div data-v-72a40ca0="" class="bet-record-card full-width q-card q-card--flat no-shadow" data-v-21f17103="">
              <template v-for="(wager, index) in statement.last10wagerList">
                <div data-v-72a40ca0="" class="border-shq-card-actionsadow">
                  <div data-v-72a40ca0="" class="q-card__actions q-card__actions--horiz vrow justify-start">
                    <div data-v-72a40ca0="" class="bet-record-title">
                      <template v-if="wager.mulpDetails">
                        {{ betLang['BETTING.LBL_PARLAY'] }} {{ betLang["BETTING.LBL_PARLAY_"+wager.tbet] }} (1 {{betLang["BETTING.LBL_PARLAY_BET"]}})
                      </template>
                      <template v-else>
                        {{ betLang['BETTING.LBL_SINGLE'] }}
                      </template>
                    </div>
                    <div data-v-72a40ca0="" class="bet-record-title">
                      <span data-v-72a40ca0="" class=""></span>
                    </div>
                  </div>
                  <template v-if="wager.mulpDetails">
                    <template v-for="(mulp, key) in wager.mulpDetails">
                      <div data-v-72a40ca0="" class="bet-item relative-position cursor-pointer">
                        <div data-v-72a40ca0="" class="q-card__section q-card__section--vert">
                          <div data-v-7f8dbb2c="" data-v-72a40ca0="">
                            <div data-v-7f8dbb2c="" class="vrow">
                              <div data-v-7f8dbb2c="" class="col bet-league-name">
                                <span data-v-7f8dbb2c="">{{ mulp.lgCap }}</span>
                              </div>
                            </div>
                            <div data-v-7f8dbb2c="" class="vrow" v-if="mulp.taCap && mulp.tbCap">
                              <div data-v-7f8dbb2c="" class="col bet-against">
                                <span data-v-7f8dbb2c="" class="home-vs-away">
                                  {{ mulp.taCap }}
                                  <span data-v-7f8dbb2c="" class="bet-pk">v</span>
                                  {{ mulp.tbCap }}
                                </span>
                                <span data-v-7f8dbb2c="" v-show="isRB(mulp.betTypId) && mulp.sprtId==1">({{ mulp.rbscoa!=undefined? mulp.rbscoa:wager.rbscoa }}-{{ mulp.rbscob!=undefined? mulp.rbscob:wager.rbscob }})</span>
                              </div>
                            </div>
                            <div data-v-7f8dbb2c="" class="vrow">
                              <div data-v-7f8dbb2c="" class="col match-time"> {{ mulp.eveDate | date('MM/DD HH:mm') }}</div>
                            </div>
                            <div data-v-7f8dbb2c="" class="bet-content">
                              <div data-v-7f8dbb2c="" class="vrow">
                                <div data-v-7f8dbb2c="" class="col bet-play-game yb-fontsize13">
                                  <label data-v-7f8dbb2c="" class="bet-play-handicap">
                                    <label data-v-7f8dbb2c="" class="sport-name">[{{ mulp.sprtCap }}]</label>
                                    <template v-if="mulp.betTypId != 14">
                                      <template v-if="mulp.plyTypId != ftPlyType">
                                        {{ betLang["BETTING.LBL_1H"] }} -
                                      </template>
                                      <template v-else-if="mulp.betTypId == '4'">
                                        {{ betLang["BETTING.LBL_FT"] }} -
                                      </template>
                                      {{ mulp.plyTypCap + ' - ' + mulp.betTypCap }}
                                      <!-- {{ BetTypeLang[mulp.betTypId]["caption"] }} -->
                                    </template>
                                    <label data-v-7f8dbb2c="" class="bet-handicap-name">[{{ wager.odTypCap }}]</label>
                                  </label>
                                </div>
                              </div>
                              <div data-v-7f8dbb2c="" class="vrow">
                                <div data-v-7f8dbb2c="" class="col bet-play-team">
                                  <span data-v-7f8dbb2c="" class="part-one">
                                    {{ drawTeamBet(mulp) }}
                                    <template v-if="hdpDisp == '0'">
                                      <template v-if="mulp.betTypId == '2' || mulp.betTypId == '9' || mulp.betTypId == '1' || mulp.betTypId == '8' || mulp.betTypId == '46' || mulp.betTypId == '47' || mulp.betTypId == '48' || mulp.betTypId == '49'">
                                        <template v-if="mulp.betTypId == '1' || mulp.betTypId == '8'">
                                          {{ mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+' }}
                                        </template>{{ mulp.hdp }}
                                      </template>
                                    </template>
                                    <template v-else-if="hdpDisp == '1'">
                                        <template v-if="mulp.betTypId == '2' || mulp.betTypId == '9' || mulp.betTypId == '46' || mulp.betTypId == '47' || mulp.betTypId == '48' || mulp.betTypId == '49'">
                                          {{ mulp.hdp }}
                                        </template>
                                        <template v-else-if="mulp.betTypId == '1' || mulp.betTypId == '8'">
                                          {{ mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+' }} {{ mulp.hdp }}
                                        </template>
                                    </template>
                                    <template v-else>
                                        <span v-if="mulp.betTypId == '1' || mulp.betTypId == '8'">
                                          {{ mulp.hdpVal<0?'-':mulp.hdpVal==0?'':'+' }}
                                        </span>{{ mulp.hdp }}
                                    </template>
                                  </span>
                                </div>
                              </div>
                              <div data-v-7f8dbb2c="" class="vrow">
                                <div data-v-7f8dbb2c="" class="col">
                                  <label data-v-7f8dbb2c="" class="bet-odds-value">
                                    <span data-v-7f8dbb2c="">@</span>{{ mulp.od }}
                                  </label>
                                </div>
                                <div data-v-7f8dbb2c="" class="col-auto bet-result">
                                  <template v-if="mulp.wgStatus < 0">
                                    <template v-if="mulp.cclrsnid > 0">
                                      <span data-v-7f8dbb2c="" class="invalid serial-msg" :title="langList.statementLang['STATEMENT.LBL_CANCELLED'] + (mulp.cclrsn != undefined? ' ('+mulp.cclrsn+')':'')">
                                        {{ langList.statementLang['STATEMENT.LBL_CANCELLED'] }}
                                        <template v-if="mulp.cclrsn != undefined">
                                          ({{ mulp.cclrsn }})
                                        </template>
                                      </span>
                                    </template>
                                    <template v-else>
                                      <span data-v-7f8dbb2c="" class="invalid serial-msg">
                                        <template v-if="mulp.wgStatus == '-3'">
                                          {{ langList.statementLang['STATEMENT.LBL_REFUND'] }}
                                        </template>
                                        <template v-else>
                                          {{ langList.statementLang['STATEMENT.LBL_REJECTED'] }}
                                        </template>
                                      </span>
                                    </template>
                                  </template>
                                  <template v-else>
                                    <span data-v-7f8dbb2c=""></span>
                                  </template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div data-v-72a40ca0="" class="bet-item relative-position cursor-pointer">
                      <div data-v-72a40ca0="" class="q-card__section q-card__section--vert">
                        <div data-v-7f8dbb2c="" data-v-72a40ca0="">
                          <div data-v-7f8dbb2c="" class="vrow">
                            <div data-v-7f8dbb2c="" class="col bet-league-name">
                              <span data-v-7f8dbb2c="">{{ wager.lgCap }}</span>
                            </div>
                          </div>
                          <div data-v-7f8dbb2c="" class="vrow" v-if="wager.taCap && wager.tbCap">
                            <div data-v-7f8dbb2c="" class="col bet-against">
                              <span data-v-7f8dbb2c="" class="home-vs-away">
                                <span v-html="wager.taCap"></span>
                                <span data-v-7f8dbb2c="" class="bet-pk">v</span>
                                <span v-html="wager.tbCap"></span>
                              </span>
                              <span data-v-7f8dbb2c="" v-show="isRB(wager.betTypId) && wager.sprtId==1">({{ wager.rbscoa }}-{{ wager.rbscob }})</span>
                            </div>
                          </div>
                          <div data-v-7f8dbb2c="" class="vrow">
                            <div data-v-7f8dbb2c="" class="col match-time">{{ wager.eveDate | date('MM/DD HH:mm') }}</div>
                          </div>
                          <div data-v-7f8dbb2c="" class="bet-content">
                            <div data-v-7f8dbb2c="" class="vrow">
                              <div data-v-7f8dbb2c="" class="col bet-play-game yb-fontsize13">
                                <label data-v-7f8dbb2c="" class="bet-play-handicap">
                                  <template v-if="wager.sprtId == specialEventList['id']"><span class="sport-name" style="display: inline-flex; align-items: center;"><label class="sport-img img36 SP"></label>[{{wager.sprtCap}}]</span><br></template>
                                  <label data-v-7f8dbb2c="" class="sport-name" v-else>[{{ wager.sprtCap }}]</label>
                                  <template v-if="isRB(wager.betTypId)">
                                    {{ sportTableLang.table['SPORT_TABLE.LBL_INPLAY']+' '  }}
                                  </template>
                                  <template v-else>
                                    {{ sportTableLang.table['SPORT_TABLE.PREMATCH']+' '  }}
                                  </template>
                                  <template v-if="wager.betTypId != 15">
                                    <template v-if="wager.plyTypId == 2">
                                      {{ betLang["BETTING.LBL_1H"] }} -
                                    </template>
                                    <template v-else-if="wager.betTypId == '4' && wager.plyTypId == 1">
                                      {{ betLang["BETTING.LBL_FT"] }} -
                                    </template>
                                      {{ wager.plyTypCap + ' - ' + wager.betTypCap }}
                                      <!-- {{ BetTypeLang[mulp.betTypId]["caption"] }} -->
                                  </template>
                                  
                                  <label data-v-7f8dbb2c="" class="bet-handicap-name">[{{wager.odTypCap}}]</label>
                                </label>
                              </div>
                            </div>
                            <div data-v-7f8dbb2c="" class="vrow">
                              <div data-v-7f8dbb2c="" class="col bet-play-team">
                                <span data-v-7f8dbb2c="" class="part-one">
                                  {{ drawTeamBet(wager) }}
                                  <template v-if="hdpDisp == '0'">
                                    <template v-if="wager.betTypId == '2' || wager.betTypId == '9' || wager.betTypId == '1' || wager.betTypId == '8' || wager.betTypId == '46' || wager.betTypId == '47' || wager.betTypId == '48' || wager.betTypId == '49'">
                                      {{ wager.hdp }}
                                    </template>
                                  </template>
                                  <template v-else-if="hdpDisp == '1'">
                                      <template v-if="wager.betTypId == '2' || wager.betTypId == '9' || wager.betTypId == '46' || wager.betTypId == '47' || wager.betTypId == '48' || wager.betTypId == '49'">
                                        {{ wager.hdp }}
                                      </template>
                                      <template v-else-if="wager.betTypId == '1' || wager.betTypId == '8'">
                                        {{ wager.hdpVal<0?'-':wager.hdpVal==0?'':'+' }}{{ wager.hdp }}
                                      </template>
                                  </template>
                                  <template v-else>
                                    {{ wager.hdpVal<0?'-':wager.hdpVal==0?'':'+' }}{{ wager.hdp }}
                                  </template>
                                </span>
                              </div>
                            </div>
                            <div data-v-7f8dbb2c="" class="vrow">
                              <div data-v-7f8dbb2c="" class="col">
                                <label data-v-7f8dbb2c="" class="bet-odds-value">
                                  <span data-v-7f8dbb2c="">@</span>{{ getDecimalDisplay(wager.odTypid, wager.od) }}
                                </label>
                              </div>
                              <div data-v-7f8dbb2c="" class="col-auto bet-result">
                                <span data-v-7f8dbb2c=""></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div data-v-72a40ca0="" class="bet-item-result q-card__section q-card__section--vert">
                    <div data-v-799b9584="" data-v-72a40ca0="">
                      <div data-v-799b9584="" class="vrow">
                        <div data-v-799b9584="" class="col bet-money">{{ betLang["BETTING.LBL_TTLSTAKE"] }}</div>
                        <div data-v-799b9584="" class="col-auto bet-money">{{ betLang['BETTING.HIGH_WIN'] }}</div>
                      </div>
                      <div data-v-799b9584="" class="vrow bet-win-input">
                        <div data-v-799b9584="" class="col bet-value">{{ wager.stkF | number(2) }}</div>
                        <div data-v-799b9584="" class="col-auto bet-value">{{ wager.estWin | number(2) }}</div>
                      </div>          
                    </div>
                  </div>
                  <div data-v-72a40ca0="" class="bet-item-separator q-card__section q-card__section--vert bet-item-separator-last"></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="statement.last10wagerList.length == 0 && !reloadingBet">
          <div class="column yb-flex-center empty fit">
            <div class="wrap empty-wrap" style="margin-top: 30px;">
              <div data-v-31145778="" class="img dark" style="width: 180px; height: 180px;"></div>
              <div class="text-center">{{ betLang['BETTING.NO_DATA'] }}</div>
            </div>
          </div>
      </template>
      <template v-else-if="reloadingBet">
        <div data-v-21f17103="" class="column yb-flex-center empty">
            <div data-v-7eebf246="" class="load-data-wrap fit video-loading loading-wrap yb-flex-center relative-position">
              <div data-v-7eebf246="" class="img-loading custom-format-img-loading"></div>
              <div data-v-7eebf246="" class="loading-text">{{ betLang['BETTING.LOADING'] }}</div>
            </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex'
  import DateFilter from '@/vue/filters/date'
  import VueFilterNumber from '@/vue/filters/vue-filter-number'
  import allBetMixin from '@/vue/mixins/allBet'
  import wagersMixins from '@/vue/mixins/wagersMixins'
  import eventBus from '../../../events/event-bus';

  export default {
    mixins: [ allBetMixin, wagersMixins ],
    computed: {
      ...mapGetters([
        'account',
        'betLang',
        'statement',
        'betLang',
        'selectedMarket',
        'BetTypeLang',
        'betting',
        'isPlacedBet',
        'hdpDisp',
        'sportAllBetLang',
        'selectedBetListType',
        'pendingFlag',
        'selectedTab',
        'langList',
        'specialEventList'
      ])
    },
    watch: {
      'statement': {
        handler(val, oldVal) {
          this.pendingWagerIds = _.map( _.filter(this.statement.last10wagerList, { wgStatus: '1' }) , 'wgNo')
          this.checkPendingWager()
        },
        deep: true,
        immediate: true,
      },
    },
    data(){
      return {
        reloadingBet: true,
        pendingWagerIds: null,
        pendingTimerId: null,
        hover: false,
        isOpen: false,
        waitingTimer: 10,
        fixTimer: 5,
      }
    },
    methods : {
      getDecimalDisplay(otid, value) {
          if(otid=='6'){
            return parseFloat(value).toFixed(0);
          }
          // return parseFloat(value).toFixed(2);
          return Math.floor(parseFloat(value) * 100) / 100;
      },
      checkRunningBettype(bettype, sprtId){
        if(this.rbettype.indexOf(bettype) < 0 || sprtId != '1' ){
          return false
        }
        return true
      },
      checkPendingWager() {
        if(this.pendingTimerId == null){
          this.pendingTimerId = setInterval((() => {
            if(this.waitingTimer - 1 < 0){
              this.waitingTimer = this.fixTimer
              if(this.pendingWagerIds.length > 0) {
                this.$store.dispatch('getPendingWager', {
                  'wagerIds': this.pendingWagerIds,
                  'callback': (res) => {
                    if(res){
                      for (let index = 0; index < res.wagerList.data.length; index++) {
                        const wager = res.wagerList.data[index];
                        if(wager.wgStatus != '1') {
                          if(wager.wgStatus == '0' || wager.wgStatus == '2'){
                            this.$store.commit('BETLIST_TYPE', 1)
                            eventBus.$emit('upWaitStatus')
                          }else if(wager.wgStatus == '-1' || wager.wgStatus == '-2'){
                            this.$store.commit('BETLIST_TYPE', 3)
                            eventBus.$emit('upWaitStatus')
                          }
                          this.pendingWagerIds.splice(index,1)
                          var last10Index = _.findIndex(this.statement.last10wagerList, {wgNo: wager.wgNo})
                          this.$set(this.statement.last10wagerList, last10Index, wager)
                        }
                      }
                    }
                  }
                })
              }
            }else{
              this.waitingTimer -= 1
            }
          }).bind(this),1000);
        }
      },
      getLast10Bets() {
        this.reloadingBet = true
        this.$store.dispatch('getLast10Wager',{
          token: token.arr_5,
          last10Wager: true,
          callback: ((res)=> {
            this.pendingWagerIds = _.map( _.filter(res.wagerList.data, { wgStatus: '1' }) , 'wgNo')
            this.checkPendingWager()
            this.reloadingBet = false
             var mini = $('.sidebar-first').hasClass('mini');
             if(mini){
               $('#betSlipForm').css('width', '17em');
             }
             
          }).bind(this)
        })
      },
      showMulpDetails(index) {
        this.$set(this.statement.last10wagerList[index], 'hide', !this.statement.last10wagerList[index].hide)
        var active = $('#'+index).hasClass('active')

        if(active){
          $('#'+index).removeClass('active')
          this.isOpen = true
        }else{
          $('#'+index).addClass('active')
          this.isOpen = false
        }
      },
      isRB(bt){
          if($.inArray(bt, this.rbettype) > -1){
              return true;
          }
          return false;
      },
      drawTeamBet(wager){
            var display=wager.tbetCap;
            if(wager.betTypId == 2 || wager.betTypId == 9 || wager.betTypId == 46 || wager.betTypId == 47 || wager.betTypId == 48 || wager.betTypId == 49) {
              if(wager.tbet=='over'){
                display=this.sportAllBetLang['ALL_BET.LBL_OVER']
              }else if(wager.tbet=='under'){  
                display=this.sportAllBetLang['ALL_BET.LBL_UNDER']
              }
            }else if(wager.betTypId == 6 || wager.betTypId == 17) {
                var htft = wager.tbet.split("")
                if(htft[0] === 'h' && htft[1] === 'h'){
                display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_HOME']
                }else if(htft[0] === 'h' && htft[1] === 'd'){
                display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH']
                }else if(htft[0] === 'h' && htft[1] === 'a'){
                display = this.sportAllBetLang['ALL_BET.LBL_HOME'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY']
                }else if(htft[0] === 'd' && htft[1] === 'h'){
                display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / '+  this.sportAllBetLang['ALL_BET.LBL_HOME']
                }else if(htft[0] === 'd' && htft[1] === 'd'){
                display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH']
                }else if(htft[0] === 'd' && htft[1] === 'a'){
                display = this.sportAllBetLang['ALL_BET.LBL_PUSH'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY']
                }else if(htft[0] === 'a' && htft[1] === 'h'){
                display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_HOME']
                }else if(htft[0] === 'a' && htft[1] === 'd'){
                display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_PUSH']
                }else if(htft[0] === 'a' && htft[1] === 'a'){
                display = this.sportAllBetLang['ALL_BET.LBL_AWAY'] + ' / ' + this.sportAllBetLang['ALL_BET.LBL_AWAY']
                }
                return display
            }else if(wager.betTypId == '19' || wager.betTypId == '20') {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha') { //is bet home away
                    display =  this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'];
                } else if (wager.tbetid == 'hd' || wager.tbet == 'hd') { //is bet home draw
                    display =  this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'];
                } else { //is bet away draw
                    display =  this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'];
                }
            }else if(wager.betTypId == 5 || wager.betTypId == 18) {
                if(wager.tbetid == '7' || wager.tbet == '7' || wager.tbetid == 'tg7' || wager.tbet == 'tg7'){
                    if(wager.plyTypId==1) {
                        display =  '7 +';
                    } else if (wager.plyTypId==2) {
                        display =  '3 +';
                    } 
                }
            }else  if (wager.tbetid == 'aos' || wager.tbet == 'aos') {
                display =  'AOS';
            }else if (wager.betTypId == 63 || wager.betTypId == 64) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = wager.taCap + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = wager.taCap + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = wager.tbCap + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = wager.tbCap + ' ' +this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }
            }else if (wager.betTypId == 57 || wager.betTypId == 58) {
                if(wager.tbetid == 'ng0' || wager.tbet == 'ng0'){
                    display = '0'
                }else if(wager.tbetid == 'ng1' || wager.tbet == 'ng1'){
                    display = '1'
                }else if(wager.tbetid == 'ng2' || wager.tbet == 'ng2'){
                    display = '2'
                }else if(wager.tbetid == 'ng3' || wager.tbet == 'ng3'){
                    display = '3'
                }else if(wager.tbetid == 'ng4' || wager.tbet == 'ng4'){
                    display = '4'
                }else if(wager.tbetid == 'ng5' || wager.tbet == 'ng5'){
                    display = '5'
                }else if(wager.tbetid == 'ng6' || wager.tbet == 'ng6'){
                    display = '6+'
                }
            }else if (wager.betTypId == 65 || wager.betTypId == 66) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }
            }else if (wager.betTypId == 59 || wager.betTypId == 73) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_ODD']
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_EVEN']
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_ODD']
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_EVEN']
                }
            }else if (wager.betTypId == 60 || wager.betTypId == 61) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }
            }else if (wager.betTypId == 62) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }
            }else if (wager.betTypId == 67) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = wager.taCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = wager.tbCap + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }
            }else if (wager.betTypId == 68 || wager.betTypId == 69) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_OVER'] + ' ' + wager.hdp
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_UNDER'] + ' ' + wager.hdp
                }
            }else if (wager.betTypId == 70 || wager.betTypId == 71) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_YES']
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + this.sportAllBetLang['ALL_BET.LBL_NO']
                }
            }else if (wager.betTypId == 72) {
                if(wager.tbetid == 'ha' || wager.tbet == 'ha'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'hb' || wager.tbet == 'hb'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }else if(wager.tbetid == 'da' || wager.tbet == 'da'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'db' || wager.tbet == 'db'){
                    display = this.sportAllBetLang['ALL_BET.LBL_HOME_OR_AWAY'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }else if(wager.tbetid == 'aa' || wager.tbet == 'aa'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.taCap
                }else if(wager.tbetid == 'ab' || wager.tbet == 'ab'){
                    display = this.sportAllBetLang['ALL_BET.LBL_AWAY_OR_DRAW'] + ' ' + this.sportAllBetLang['ALL_BET.AND'] + ' ' + wager.tbCap
                }
            }
            const parser = new DOMParser();
            return parser.parseFromString(display, "text/html").body.textContent;
            // return display;
        }
    },
    mounted() {
      //this.getLast10Bets() 
      $('.ellipsis').bind('mouseenter', function(){
          var $this = $(this);
          if(this.offsetWidth < this.scrollWidth && !$this.attr('title')){
              $this.attr('title', $this.text());
          }
      });
    },
    beforeMount() {
      let Vue=this;
      eventBus.$on("reloadingLast10Wager", reloadingReturn => {
        Vue.reloadingBet = reloadingReturn
        Vue.pendingWagerIds = _.map( _.filter(Vue.statement.last10wagerList, { wgStatus: '1' }) , 'wgNo')
        Vue.checkPendingWager()
        
      })
      /*
      eventBus.$on('reloadingLast10Wager', ((reloading)=> {
        this.pendingWagerIds = _.map( _.filter(this.statement.last10wagerList, { wgStatus: '1' }) , 'wgNo')
        this.checkPendingWager()
        this.reloading = reloading
      }).bind(this))*/
    },
    beforeDestroy() {
      eventBus.$off('reloadingLast10Wager')
      clearInterval(this.pendingTimerId)
    }
  }
</script>
<style lang="scss" scoped>
 // @import "~@/styles/base/global";
//  @import "~@/styles/home/contentsLeft/betSlipForm";

</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/betSlipForm.vue